import React from 'react';

const StuCertificates = () => {
    return (
        <div>
            Certificates
        </div>
    );
};

export default StuCertificates;